// extracted by mini-css-extract-plugin
export default {"container":"UnreadIndicator-module__container--X6F4o"};